/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * 도어캠 부가서비스 API
 * API documentation for 도어캠 부가서비스
 * OpenAPI spec version: 1.0
 */

/**
 * 응답 결과 상태
 */
export type AccessUrlResDtoResult = (typeof AccessUrlResDtoResult)[keyof typeof AccessUrlResDtoResult];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessUrlResDtoResult = {
  success: 'success',
  fail: 'fail',
} as const;
